import { createLucideIcon } from "lucide-react";

export const MinusPlusSquare = createLucideIcon(
    "MinusPlusSquare",
    [
        [
            "path",
            {
                d: "M1.66602 8C1.66602 5.01444 1.66602 3.52166 2.59351 2.59416C3.52101 1.66667 5.01379 1.66667 7.99935 1.66667C10.9849 1.66667 12.4777 1.66667 13.4052 2.59416C14.3327 3.52166 14.3327 5.01444 14.3327 8C14.3327 10.9856 14.3327 12.4783 13.4052 13.4058C12.4777 14.3333 10.9849 14.3333 7.99935 14.3333C5.01379 14.3333 3.52101 14.3333 2.59351 13.4058C1.66602 12.4783 1.66602 10.9856 1.66602 8Z",
                key: "evefko",
            },
        ],
        [
            "path",
            {
                d: "M11.3327 4.6667L4.666 11.3333",
                key: "khprbd",
            },
        ],
        [
            "path",
            {
                d: "M4.666 6L7.3327 6",
                key: "zx3yiz",
            },
        ],
        [
            "path",
            {
                d: "M9.9994 10L11.3327 10",
                key: "1h9alm",
            },
        ],
        [
            "path",
            {
                d: "M9.9994 10L8.666 10",
                key: "f0l7up",
            },
        ],
        [
            "path",
            {
                d: "M9.9994 10V8.6667",
                key: "mgker1",
            },
        ],
        [
            "path",
            {
                d: "M9.9994 11.3333L9.9994 10",
                key: "1w20wg",
            },
        ],
    ],
);
